import React from "react";
import { useNavigate } from "react-router-dom";
/** Components Import */
import EmptyBox from "../../Components/EmptyBox";
import Card from "../../Components/Card_wrap";
import BasicArea from "../../Components/PDA/BarcodeArea";
import BasicInput from "../../Components/Input_Basic";
import BasicCombo from "../../Components/Combo_Basic";
import CardH3 from "../../Components/Card_H3";
import BasicButton from "../../Components/Button_Basic";
import BasicRadio from "../../Components/Radio_Basic";
import BasicModal from "../../Components/Modal_Basic";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus as PlusIcon,
  faMinus as MinusIcon,
} from "@fortawesome/free-solid-svg-icons";
import FormGroup from "../../Components/Form_Group";

function MM10061(props) {
  const [modalToggle, setModalToggle] = React.useState(false);
  const [modalToggle1, setModalToggle1] = React.useState(false);
  const navigate = useNavigate();
  const [inputs, setInputs] = React.useState({
    wkSeq: "",
    worker: "",
    wkOutSrc: "in",
    wkType: "tomson",
    seqQty: 0,
    seqFailQty: 0,
    radioJumpQty: "10",
    radioJumpQty1: "10",
  });
  // const [comboYears, setComboYears] = React.useState([
  //   2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026,
  // ]);
  // const [comboMonth, setComboMonth] = React.useState([]);
  // const [comboDay, setComboDay] = React.useState([]);
  // const [comboHours, setComboHours] = React.useState([]);
  // const [comboMin, setComboMin] = React.useState([]);
  // React.useEffect(() => {
  //   let month = [];
  //   let day = [];
  //   let hour = [];
  //   let min = [];
  //   for (let i = 1; i < 13; i++) {
  //     month.push(i);
  //   }
  //   for (let i = 1; i < 32; i++) {
  //     day.push(i);
  //   }
  //   setComboMonth(month);
  // }, []);

  return (
    <div>
      <EmptyBox />
      <Card
        wrapStyle={{
          height: "25vh",
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        <CardH3 name={props.inputs.processNm + " 실적화면"} />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
          }}
        >
          <BasicInput
            containerStyle={{ flexWrap: "noWrap", width: "250px" }}
            name="작업자"
            value={props.woNoInputs.worker}
            disabled={true}
          />
          <BasicCombo
            style={{ marginRight: "50px" }}
            containerStyle={{ flexWrap: "noWrap" }}
            name="설비명"
            combos={props.machineData}
            value={props.machineInputs.machineCd}
            onChange={(e) => {
              props.setMachineInputs({
                ...props.machineInputs,
                machineCd: e,
              });
            }}
            // disabled={true}
          />
        </div>
        {/* <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <BasicButton
            style={{ marginRight: "10px", marginTop: "10px" }}
            name="지난 공정"
            onClick={(e) => {
              setModalToggle(true);
              props.GetLastProcessCd();
            }}
          />
        </div> */}
      </Card>
      <Card
        wrapStyle={{
          // flexDirection: "column",
          // display: "flex",
          // alignItems: "start",
          // justifyContent: "center",
          height: "45vh",
        }}
      >
        {/* <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              margin: "10px",
              padding: "5px",
            }}
          >
            <label
              style={{
                top: 0,
                minWidth: "100px",
                paddingRight: "10px",
                paddingLeft: "10px",
                color: "#4e4e4e",
                fontSize: "14px",
                cursor: "default",
              }}
            >
              제대
            </label>
            <BasicRadio
              style={{
                display: "flex",
                alignItems: "center",
              }}
              gubun={1}
              value={props.woNoInputs.wkType}
              onChange={(e) => {
                props.setWoNoInputs({
                  ...props.woNoInputs,
                  wkType: e.target.value,
                });
              }}
              items={[
                {
                  value: "Y",
                  name: "톰슨",
                  checked: true,
                },
                { value: "N", name: "기계제대" },
              ]}
            />
          </div>
        </div> */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
          }}
        >
          <BasicInput
            containerStyle={{ flexWrap: "noWrap", width: "250px" }}
            name="카톤입수량"
            value={props.woNoInputs.cartonQuantity}
            onChange={(e) => {
              props.setWoNoInputs({
                ...props.woNoInputs,
                cartonQuantity: e.target.value,
              });
            }}
          />
          <BasicInput
            containerStyle={{ flexWrap: "noWrap", width: "250px" }}
            name="비고"
            value={props.woNoInputs.remark}
            onChange={(e) => {
              props.setWoNoInputs({
                ...props.woNoInputs,
                remark: e.target.value,
              });
            }}
          />
          <BasicInput
            containerStyle={{ flexWrap: "noWrap", width: "250px" }}
            name="양품수량"
            value={props.woNoInputs.seqQty}
            onChange={(e) => {
              props.setWoNoInputs({
                ...props.woNoInputs,
                seqQty: e.target.value,
              });
            }}
            inputMode="decimal"
          />{" "}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            margin: "0px 10px",
          }}
        >
          <BasicRadio
            style={{
              display: "flex",
              alignItems: "center",
            }}
            gubun={2}
            value={props.woNoInputs.radioJumpQty}
            onChange={(e) => {
              props.setWoNoInputs({
                ...props.woNoInputs,
                radioJumpQty: e.target.value,
              });
            }}
            items={[
              { value: "10", name: "10", checked: true },
              { value: "100", name: "100" },
              { value: "1000", name: "1000" },
            ]}
          />
          <div>
            <BasicButton
              icon={PlusIcon}
              onClick={(e) => {
                props.setWoNoInputs({
                  ...props.woNoInputs,
                  seqQty:
                    props.woNoInputs.seqQty * 1 +
                    props.woNoInputs.radioJumpQty * 1,
                });
              }}
            />
            <BasicButton
              icon={MinusIcon}
              onClick={(e) => {
                if (
                  props.woNoInputs.seqQty * 1 -
                    props.woNoInputs.radioJumpQty * 1 <
                  0
                ) {
                  props.setWoNoInputs({
                    ...props.woNoInputs,
                    seqQty: 0,
                  });
                } else {
                  props.setWoNoInputs({
                    ...props.woNoInputs,
                    seqQty:
                      props.woNoInputs.seqQty * 1 -
                      props.woNoInputs.radioJumpQty * 1,
                  });
                }
              }}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
          }}
        >
          <BasicInput
            containerStyle={{ flexWrap: "noWrap", width: "250px" }}
            name="불량수량"
            value={props.woNoInputs.seqFailQty}
            onChange={(e) => {
              props.setWoNoInputs({
                ...props.woNoInputs,
                seqFailQty: e.target.value,
              });
            }}
            inputMode="decimal"
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            margin: "0px 10px",
          }}
        >
          <BasicRadio
            style={{
              display: "flex",
              alignItems: "center",
            }}
            gubun={3}
            value={props.woNoInputs.radioJumpQty1}
            onChange={(e) => {
              props.setWoNoInputs({
                ...props.woNoInputs,
                radioJumpQty1: e.target.value,
              });
            }}
            items={[
              { value: "10", name: "10", checked: true },
              { value: "100", name: "100" },
              { value: "1000", name: "1000" },
            ]}
          />
          <div>
            <BasicButton
              icon={PlusIcon}
              onClick={(e) => {
                props.setWoNoInputs({
                  ...props.woNoInputs,
                  seqFailQty:
                    props.woNoInputs.seqFailQty * 1 +
                    props.woNoInputs.radioJumpQty1 * 1,
                });
              }}
            />
            <BasicButton
              icon={MinusIcon}
              onClick={(e) => {
                if (
                  props.woNoInputs.seqFailQty * 1 -
                    props.woNoInputs.radioJumpQty1 * 1 <
                  0
                ) {
                  props.setWoNoInputs({
                    ...props.woNoInputs,
                    seqFailQty: 0,
                  });
                } else {
                  props.setWoNoInputs({
                    ...props.woNoInputs,
                    seqFailQty:
                      props.woNoInputs.seqFailQty * 1 -
                      props.woNoInputs.radioJumpQty1 * 1,
                  });
                }
              }}
            />
          </div>
        </div>
      </Card>
      <Card
        wrapStyle={{
          height: "10vh",
        }}
      >
        <div
          style={{
            height: "10vh",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0px 10px",
          }}
        >
          <BasicButton
            name="뒤로"
            onClick={(e) => {
              // navigate("/MM10060");
              props.setProcessCdCheck(false);
              props.setMachineInputs({
                machineCd: "",
              });
            }}
          />
          {/* <BasicButton
            name="시작시간 변경"
            onClick={(e) => {
              setModalToggle1(true);
            }}
          /> */}
          <BasicButton
            name="저장"
            onClick={(e) => {
              props.SaveConfirm();
              // props.setWoNoInputs(
              //   ...props.woNoInputs,
              //   {
              //     // wkSeq: -1,
              //     // worker: "",
              //     // wkOutSrc: "Y",
              //     // wkType: "Y",
              //     // wkStDt: "",
              //     // wkEdDt: new Date(),
              //     // seqQty: 0,
              //     // seqFailQty: 0,
              //     radioJumpQty: "10",
              //     radioJumpQty1: "10",
              //   });
              props.setInputs({
                ...props.inputs,
                processList: [],
                barcodeValue: "",
                switchValue: false,
                workOrderValue: "",
                woNo: "",
                // userNm: "",
                itemCd: "",
                itemNm: "",
                itemType: "",
                processCd: "",
                wkStDt: "",
              });
            }}
          />
        </div>
      </Card>
      {modalToggle && (
        <BasicModal
          name="지난공정"
          onClose={() => setModalToggle(false)}
          buttonName1="확인"
          hidden={true}
          execLogic={() => {}}
        >
          <FormGroup
            columnCount={1}
            datas={[
              {
                name: "작업자",
                inputClass: "input",
                value: props.lsatProcessList.createId,
                onChange: (e) => {
                  let { value } = { ...e.target };
                  props.setLastProcessList({
                    ...props.lsatProcessList,
                    createId: value,
                  });
                },
                readOnly: true,
              },
              {
                name: "공정명",
                inputClass: "input",
                value: props.lsatProcessList.processNm,
                onChange: (e) => {
                  let { value } = { ...e.target };
                  props.setLastProcessList({
                    ...props.lsatProcessList,
                    processNm: value,
                  });
                },
                readOnly: true,
              },
              // {
              //   name: "외주유무",
              //   inputClass: "input",
              //   value: props.lsatProcessList.woNo ,
              //   onChange: (e) => {
              //     let { value } = { ...e.target };
              //     props.setLastProcessList({
              //       ...props.lsatProcessList,
              //       woNo: value,
              //     });
              //   },
              // },
              {
                name: "작업시간",
                inputClass: "input",
                value: props.lsatProcessList.wkTime,
                onChange: (e) => {
                  let { value } = { ...e.target };
                  props.setLastProcessList({
                    ...props.lsatProcessList,
                    wkTime: value,
                  });
                },
                readOnly: true,
              },
              {
                name: "공정 양품 수량",
                inputClass: "input",
                value: props.lsatProcessList.seqQty,
                onChange: (e) => {
                  let { value } = { ...e.target };
                  props.setLastProcessList({
                    ...props.lsatProcessList,
                    seqQty: value,
                  });
                },
                readOnly: true,
              },
              {
                name: "공정 불량 수량",
                inputClass: "input",
                value: props.lsatProcessList.seqFailQty,
                onChange: (e) => {
                  let { value } = { ...e.target };
                  props.setLastProcessList({
                    ...props.lsatProcessList,
                    seqFailQty: value,
                  });
                },
                readOnly: true,
              },
              {
                type: "input",
                name: "시작일시",
                value: props.lsatProcessList.wkStDt,
                onChange: (e) => {
                  props.setLastProcessList({
                    ...props.lsatProcessList,
                    wkStDt: e,
                  });
                },
                readOnly: true,
              },
              {
                type: "input",
                name: "종료일시",
                value: props.lsatProcessList.wkEtDt,
                onChange: (e) => {
                  props.setLastProcessList({
                    ...props.lsatProcessList,
                    wkEtDt: e,
                  });
                },
                readOnly: true,
              },
            ]}
          />
        </BasicModal>
      )}
      {modalToggle1 && (
        <BasicModal
          name="공정 시작시간 변경"
          onClose={() => setModalToggle1(false)}
          buttonName1="변경"
          hidden={true}
          execLogic={() => {
            props.ChangeStartTime();
          }}
        >
          <FormGroup
            columnCount={1}
            datas={[
              {
                name: "시작시간",
                inputClass: "input",
                type: "dateTime",
                value: props.startDate,
                onChange: (e) => {
                  props.setStartDate(e);
                },
                timeFormat: "HH:mm",
                timeIntervals: 15,
                timeCaption: "time",
                dateFormat: "MMMM d, yyyy h:mm aa",
              },
            ]}
          />
        </BasicModal>
      )}
    </div>
  );
}

export default MM10061;
